import { render, staticRenderFns } from "./alert-notification.vue?vue&type=template&id=2c7e4b30"
import script from "./alert-notification.vue?vue&type=script&lang=js"
export * from "./alert-notification.vue?vue&type=script&lang=js"
import style0 from "./alert-notification.vue?vue&type=style&index=0&id=2c7e4b30&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports